import { useEffect } from 'react';

type ClickOutsideHandler = () => void;

export const useClickOutside = (
  ref: React.RefObject<HTMLElement | null>,
  handler: ClickOutsideHandler,
) => {
  useEffect(() => {
    const listener = (event: MouseEvent | TouchEvent) => {
      if (!ref.current || ref.current.contains(event.target as Node)) {
        return;
      }
      handler();
    };

    document.addEventListener('mousedown', listener);
    document.addEventListener('touchstart', listener);

    return () => {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    };
  }, [ref, handler]);
};
